import { get, post } from "./Api";

export function SearchPrize({ data }) {
    return post({ url: `/api/v1/haire/member/search/prize`, data });
}

export function SearchPrizeById(prizeId) {
    return get({ url: `/api/v1/haire/member/search/prizeInfo/${prizeId}` });
}

export function UpdatePrize({ data }) {
    return post({ url: `/api/v1/haire/member/update/prize`, data });
}







